import { createSelector } from '@reduxjs/toolkit';

import { selectDealType } from 'shared/selectors/jsonQuery';
import { ISelectOption } from 'shared/types/filters';

import { EContractType } from '../../../../packages/api-models/common/json_query';
import { FDealType } from '../../../../packages/JsonQuery';

const RENT_OPTIONS: ISelectOption[] = [
  { label: 'Прямая аренда', value: EContractType.DirectRent },
  { label: 'Субаренда', value: EContractType.SubRent },
];

const SALE_OPTIONS: ISelectOption[] = [
  { label: 'Продажа', value: EContractType.ObjSale },
  { label: 'Переуступка права аренды', value: EContractType.PermTransfer },
];

export const selectContractOptions = createSelector(selectDealType, dealType => {
  if ((dealType & FDealType.Rent) !== 0) {
    return RENT_OPTIONS;
  }

  return SALE_OPTIONS;
});
